(function ($) {
    // USE STRICT
    "use strict";

    // Check if jQuery is available
    if (typeof $ === "undefined") {
        console.error("jQuery is not loaded");
        return;
    }

    /*[ Slick1 ]
    ===========================================================*/
    if ($(".slick1").length > 0) {
        const itemSlick1 = $(".slick1").find(".item-slick1");
        const action1 = [];
        const action2 = [];
        const action3 = [];
        const cap1Slide1 = [];
        const cap2Slide1 = [];
        const btnSlide1 = [];

        for(let i=0; i<itemSlick1.length; i++) {
            cap1Slide1[i] = $(itemSlick1[i]).find(".caption1-slide1");
            cap2Slide1[i] = $(itemSlick1[i]).find(".caption2-slide1");
            btnSlide1[i] = $(itemSlick1[i]).find(".wrap-btn-slide1");
        }

        // Check if slick is available as a method
        if (typeof $.fn.slick === "function") {
            $(".slick1").on("init", function(){
                action1[0] = setTimeout(function(){
                    $(cap1Slide1[0]).addClass($(cap1Slide1[0]).data("appear") + " visible-true");
                },200);

                action2[0] = setTimeout(function(){
                    $(cap2Slide1[0]).addClass($(cap2Slide1[0]).data("appear") + " visible-true");
                },1000);

                action3[0] = setTimeout(function(){
                    $(btnSlide1[0]).addClass($(btnSlide1[0]).data("appear") + " visible-true");
                },1800);
            });

            $(".slick1").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                dots: false,
                appendDots: $(".wrap-slick1-dots"),
                dotsClass:"slick1-dots",
                infinite: true,
                autoplay: true,
                autoplaySpeed: 6000,
                arrows: true,
                appendArrows: $(".wrap-slick1"),
                // eslint-disable-next-line max-len
                prevArrow:"<button class=\"arrow-slick1 prev-slick1\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button>",
                // eslint-disable-next-line max-len
                nextArrow:"<button class=\"arrow-slick1 next-slick1\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button>",
            });

            $(".slick1").on("afterChange", function(event, slick, currentSlide){
                for(let i=0; i<itemSlick1.length; i++) {
                    clearTimeout(action1[i]);
                    clearTimeout(action2[i]);
                    clearTimeout(action3[i]);

                    $(cap1Slide1[i]).removeClass($(cap1Slide1[i]).data("appear") + " visible-true");
                    $(cap2Slide1[i]).removeClass($(cap2Slide1[i]).data("appear") + " visible-true");
                    $(btnSlide1[i]).removeClass($(btnSlide1[i]).data("appear") + " visible-true");
                }

                action1[currentSlide] = setTimeout(function(){
                    $(cap1Slide1[currentSlide]).addClass($(cap1Slide1[currentSlide]).data("appear") + " visible-true");
                },200);

                action2[currentSlide] = setTimeout(function(){
                    $(cap2Slide1[currentSlide]).addClass($(cap2Slide1[currentSlide]).data("appear") + " visible-true");
                },1000);

                action3[currentSlide] = setTimeout(function(){
                    $(btnSlide1[currentSlide]).addClass($(btnSlide1[currentSlide]).data("appear") + " visible-true");
                },1800);
            });
        } else {
            console.error("Slick carousel plugin is not loaded");
        }
    }

    /*[ Slick2 ]
    ===========================================================*/
    if ($(".slick2").length > 0 && typeof $.fn.slick === "function") {
        $(".slick2").slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 6000,
            arrows: true,
            appendArrows: $(".wrap-slick2"),
            // eslint-disable-next-line max-len
            prevArrow:"<button class=\"arrow-slick2 prev-slick2\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button>",
            // eslint-disable-next-line max-len
            nextArrow:"<button class=\"arrow-slick2 next-slick2\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button>",
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    /*[ Slick3 ]
    ===========================================================*/
    if ($(".slick3").length > 0 && typeof $.fn.slick === "function") {
        $(".slick3").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: true,
            appendDots: $(".wrap-slick3-dots"),
            dotsClass:"slick3-dots",
            infinite: true,
            autoplay: false,
            autoplaySpeed: 6000,
            arrows: false,
            customPaging: function(slick, index) {
                const portrait = $(slick.$slides[index]).data("thumb");
                return "<img src=\" " + portrait + " \"/><div class=\"slick3-dot-overlay\"></div>";
            },
        });
    }

})(jQuery);
